import React, { useLayoutEffect, useRef, useContext } from "react";
import { IsOpenedAccordionContext } from "./Accordion";

import "./styleMobile.css";

const CircleProgressBar = ({ target, title }) => {
  const canvasRef = useRef(null);
  const circleNumberRef = useRef(null);
  const IsOpenedAccordion = useContext(IsOpenedAccordionContext);

  useLayoutEffect(() => {
    const circleNumber = circleNumberRef.current;
    const canvasBody = canvasRef.current;
    const dataTarget = canvasRef.current.dataset.target;

    //canvas context
    const canvasBox = canvasBody.getContext("2d");
    const canvasWidth = canvasBox.canvas.width;
    const canvasHeight = canvasBox.canvas.height;
    let canvasIndex = 0;

    const canvasControl = () => {
      canvasIndex++;
      canvasBox.beginPath();
      canvasBox.clearRect(0, 0, canvasWidth, canvasHeight);
      canvasBox.lineWidth = "11";
      canvasBox.strokeStyle = "#f24b4b";
      canvasBox.lineCap = "round";
      canvasBox.arc(150, 75, 25, 0, canvasIndex / 16);
      canvasBox.stroke();

      if (dataTarget <= canvasIndex) {
        clearInterval(canvasInterval);
      }
      circleNumber.textContent = canvasIndex;
    };

    const canvasInterval = setInterval(() => {
      IsOpenedAccordion && canvasControl();
    }, 50);
  }, [IsOpenedAccordion]);
  return (
    <>
      <section className="circle_sectionForMob">
        <div className="circle_contentForMob">
          <div className="circle_textForMob">
            <h2 className="circle_titleMob">{title}</h2>
            <p>
              <span ref={circleNumberRef} className="circle_numberForMob">
                0
              </span>
              <span>%</span>
            </p>
          </div>
          <canvas
            ref={canvasRef}
            id="circleForMob"
            data-target={target}
          ></canvas>
        </div>
      </section>
    </>
  );
};

export default CircleProgressBar;
